import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OrderBookingNotes {
  constructor($scope, OrderBookingNoteService, OrderSidebarService, UiService, EmailService) {
    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.add_booking_note = function() {
      $scope.dialog_note = angular.copy(window.booking_note);
      $scope.open_dialog('booking_note_dialog');
    };

    $scope.edit_booking_note = function(booking_note) {
      $scope.dialog_note = booking_note;
      $scope.open_dialog('booking_note_dialog');
    };

    $scope.delete_booking_note = function(index) {
      if (confirm('Are you sure you want to delete this booking note?')) {
        OrderBookingNoteService.delete($scope.order.booking_notes[index].id).then(function(data) {
          if (data.success) {
            $scope.order.booking_notes.splice(index, 1);
            OrderSidebarService.set_booking_notes_data($scope.order.booking_notes.length > 0);
          }
        });
      }
    };

    $scope.save_booking_note = function() {
      $scope.updating_note = true;
      OrderBookingNoteService.save($scope.dialog_note).then(function(data) {
        if (data.success) {
          $scope.updating_note = false;
          $.fancybox.close();
          $scope.order.booking_notes = data.booking_notes;
          OrderSidebarService.set_booking_notes_data(data.booking_notes.length > 0);
        }
      });
    };

    $scope.send_booking_note = function(booking_note) {
      $scope.dialog_booking_note = booking_note;
      $.fancybox($('div#send_booking_note'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'yes',
        afterShow: function() {
          $scope.$broadcast('$tinymce:refresh');
        }
      });
    };

    $scope.check_buyer_contacts = function() {
      _.each($scope.buyer_contacts, function(contact) {
        contact.checked = $scope.checked_all_buyer_contacts;
      });
    };

    $scope.send_booking_note_notification = function() {
      var contacts = _.where($scope.buyer_contacts, {
        checked: true
      });
      if (contacts.length === 0) {
        alert('Please select at least one buyer contact!');
        return false;
      }
      $scope.sending_booking_note_notification = true;
      OrderBookingNoteService.send_notification($scope.dialog_booking_note.id, $scope.buyer_custom_text, contacts, $scope.sender_name_en, $scope.sender_name_el, $scope.test_send, $scope.test_send_email).success(function(data) {
        if (data.success) {
          $scope.sending_booking_note_notification = false;
          $.fancybox.close();
        }
      });
    };

    $scope.get_delivery_status_title = function(status) {
      return _.findWhere($scope.delivery_statuses, {
        id: status
      }).title;
    };

    $scope.init = function() {
      $scope.order = window.order;
      $scope.dialog_note = angular.copy(window.booking_note);
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.tinymceOptions.height = 100;
      $scope.custom_text = '';
      $scope.test_send = true;
      $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
      $scope.recipient_modes = EmailService.get_recipient_modes();
      $scope.sender_names_en = EmailService.get_sender_names_en();
      $scope.sender_names_el = EmailService.get_sender_names_el();
      $scope.sender_name_en = $scope.sender_names_en[0];
      $scope.sender_name_el = $scope.sender_names_el[0];
      $scope.buyer_contacts = _.filter(window.buyer_contacts, function(c) {
        return !_.isEmpty(c.email);
      });
      _.each($scope.buyer_contacts, function(c) {
        c.recipient_mode = 0;
      });
      $scope.delivery_statuses = window.delivery_statuses;
    };

    $scope.init();
  }
}

OrderBookingNotes.$inject = ['$scope', 'OrderBookingNoteService', 'OrderSidebarService', 'UiService', 'EmailService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-booking-notes.ctrl.js